module.exports = __webpack_public_path__ + "static/media/rating_2.37228398.png";